module.exports = __webpack_public_path__ + "assets/1e996c0dc5a8541015768428fece018f.mp3";